import React from "react";
import "../CSS/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Taswik</h3>
          <p>Put the world in your hands</p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/blog">Blogs</a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Phone: +225 07 11 71 11 16</p>
        </div>
        <div className="footer-section">
          <h3>Social Media</h3>
          <div className="social-links">
            <a
              href="https://www.facebook.com/profile.php?id=61571805832912&mibextid=ZbWKwL"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="pi pi-facebook"></i>facebook
            </a>
            <a
              href="https://www.instagram.com/t.a.s.w.i.k?igsh=MTM3dmI4cGJ6YTF4dw=="
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="pi pi-instagram"></i>instagram
            </a>
            <a
              href="https://whatsapp.com/channel/0029VawYhiO0VycLTIJPJV0L"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="pi pi-whatsapp"></i>whatsapp
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Taswik. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
